import require$$0 from 'util';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var maybePromoteScalarValueIntoResponsive = function maybePromoteScalarValueIntoResponsive(value) {
  var isResponsive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  /**
   * Responsive value must necessarily have the desktop key attached to it
   */
  if (value && Object.keys(value).indexOf('desktop') > -1) {
    if (!isResponsive) {
      return value.desktop;
    }

    return value;
  }

  if (!isResponsive) {
    return value;
  }

  return {
    desktop: value,
    tablet: value,
    mobile: value
  };
};

var shadyCss = {};

var astIterator = {};

var common = {};

(function (exports) {
	/**
	 * @license
	 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
	 * This code may only be used under the BSD style license found at
	 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
	 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
	 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
	 * Google as part of the polymer project is also subject to an additional IP
	 * rights grant found at http://polymer.github.io/PATENTS.txt
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A set of common RegExp matchers for tokenizing CSS.
	 */
	const matcher = {
	    whitespace: /\s/,
	    whitespaceGreedy: /(\s+)/g,
	    commentGreedy: /(\*\/)/g,
	    boundary: /[\(\)\{\}'"@;:\s]/,
	    stringBoundary: /['"]/
	};
	exports.matcher = matcher;
	(function (nodeType) {
	    nodeType["stylesheet"] = "stylesheet";
	    nodeType["comment"] = "comment";
	    nodeType["atRule"] = "atRule";
	    nodeType["ruleset"] = "ruleset";
	    nodeType["expression"] = "expression";
	    nodeType["declaration"] = "declaration";
	    nodeType["rulelist"] = "rulelist";
	    nodeType["discarded"] = "discarded";
	})(exports.nodeType || (exports.nodeType = {}));
	
} (common));

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(astIterator, "__esModule", { value: true });
const util = require$$0;
const common_1$4 = common;
function* iterateOverAst(node) {
    yield node;
    switch (node.type) {
        case common_1$4.nodeType.stylesheet:
            for (const rule of node.rules) {
                yield* iterateOverAst(rule);
            }
            return;
        case common_1$4.nodeType.ruleset:
            return yield* iterateOverAst(node.rulelist);
        case common_1$4.nodeType.rulelist:
            for (const rule of node.rules) {
                yield* iterateOverAst(rule);
            }
            return;
        case common_1$4.nodeType.declaration:
            if (node.value !== undefined) {
                yield* iterateOverAst(node.value);
            }
            return;
        case common_1$4.nodeType.atRule:
            if (node.rulelist) {
                yield* iterateOverAst(node.rulelist);
            }
            return;
        case common_1$4.nodeType.expression:
        case common_1$4.nodeType.comment:
        case common_1$4.nodeType.discarded:
            return; // no child nodes
        default:
            const never = node;
            console.error(`Got a node of unknown type: ${util.inspect(never)}`);
    }
}
astIterator.iterateOverAst = iterateOverAst;

var nodeFactory = {};

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(nodeFactory, "__esModule", { value: true });
const common_1$3 = common;
/**
 * Class used for generating nodes in a CSS AST. Extend this class to implement
 * visitors to different nodes while the tree is being generated, and / or
 * custom node generation.
 */
class NodeFactory {
    /**
     * Creates a Stylesheet node.
     * @param rules The list of rules that appear at the top
     * level of the stylesheet.
     */
    stylesheet(rules, range) {
        return { type: common_1$3.nodeType.stylesheet, rules, range };
    }
    /**
     * Creates an At Rule node.
     * @param name The "name" of the At Rule (e.g., `charset`)
     * @param parameters The "parameters" of the At Rule (e.g., `utf8`)
     * @param rulelist The Rulelist node (if any) of the At Rule.
     */
    atRule(name, parameters, rulelist = undefined, nameRange, parametersRange, range) {
        return {
            type: common_1$3.nodeType.atRule,
            name,
            parameters,
            rulelist,
            nameRange,
            parametersRange,
            range
        };
    }
    /**
     * Creates a Comment node.
     * @param value The full text content of the comment, including
     * opening and closing comment signature.
     */
    comment(value, range) {
        return { type: common_1$3.nodeType.comment, value, range };
    }
    /**
     * Creates a Rulelist node.
     * @param rules An array of the Rule nodes found within the Ruleset.
     */
    rulelist(rules, range) {
        return { type: common_1$3.nodeType.rulelist, rules, range };
    }
    /**
     * Creates a Ruleset node.
     * @param selector The selector that corresponds to the Selector
     * (e.g., `#foo > .bar`).
     * @param rulelist The Rulelist node that corresponds to the Selector.
     */
    ruleset(selector, rulelist, selectorRange, range) {
        return { type: common_1$3.nodeType.ruleset, selector, rulelist, selectorRange, range };
    }
    /**
     * Creates a Declaration node.
     * @param name The property name of the Declaration (e.g., `color`).
     * @param value Either an Expression node, or a Rulelist node, that
     * corresponds to the value of the Declaration.
     */
    declaration(name, value, nameRange, range) {
        return { type: common_1$3.nodeType.declaration, name, value, nameRange, range };
    }
    /**
     * Creates an Expression node.
     * @param text The full text content of the expression (e.g.,
     * `url(img.jpg)`)
     */
    expression(text, range) {
        return { type: common_1$3.nodeType.expression, text, range };
    }
    /**
     * Creates a Discarded node. Discarded nodes contain content that was not
     * parseable (usually due to typos, or otherwise unrecognized syntax).
     * @param text The text content that is discarded.
     */
    discarded(text, range) {
        return { type: common_1$3.nodeType.discarded, text, range };
    }
}
nodeFactory.NodeFactory = NodeFactory;

var nodeVisitor = {};

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(nodeVisitor, "__esModule", { value: true });
/**
 * Class that implements a visitor pattern for ASTs produced by the Parser.
 * Extend the NodeVisitor class to implement useful tree traversal operations
 * such as stringification.
 */
class NodeVisitor {
    /**
     * Create a NodeVisitor instance.
     */
    constructor() {
        this.path_ = [];
    }
    /**
     * A list of nodes that corresponds to the current path through an AST being
     * visited, leading to where the currently visited node will be found.
     */
    get path() {
        return this.path_;
    }
    /**
     * Visit a node. The visited node will be added to the `path` before it is
     * visited, and will be removed after it is visited. Nodes are "visited" by
     * calling a method on the NodeVisitor instance that matches the node's type,
     * if one is available on the NodeVisitor instance.
     * @param node The node to be visited.
     * @return The return value of the method visiting the node, if any.
     */
    visit(node) {
        let result;
        const callback = this[node.type];
        if (callback) {
            this.path_.push(node);
            result = this[node.type](node);
            this.path_.pop();
        }
        return result;
    }
}
nodeVisitor.NodeVisitor = NodeVisitor;

var parser = {};

var token = {};

(function (exports) {
	/**
	 * @license
	 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
	 * This code may only be used under the BSD style license found at
	 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
	 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
	 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
	 * Google as part of the polymer project is also subject to an additional IP
	 * rights grant found at http://polymer.github.io/PATENTS.txt
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An enumeration of Token types.
	 */
	var TokenType;
	(function (TokenType) {
	    TokenType[TokenType["none"] = 0] = "none";
	    TokenType[TokenType["whitespace"] = (Math.pow(2, 0))] = "whitespace";
	    TokenType[TokenType["string"] = (Math.pow(2, 1))] = "string";
	    TokenType[TokenType["comment"] = (Math.pow(2, 2))] = "comment";
	    TokenType[TokenType["word"] = (Math.pow(2, 3))] = "word";
	    TokenType[TokenType["boundary"] = (Math.pow(2, 4))] = "boundary";
	    TokenType[TokenType["propertyBoundary"] = (Math.pow(2, 5))] = "propertyBoundary";
	    // Special cases for boundary:
	    TokenType[TokenType["openParenthesis"] = (Math.pow(2, 6)) | TokenType.boundary] = "openParenthesis";
	    TokenType[TokenType["closeParenthesis"] = (Math.pow(2, 7)) | TokenType.boundary] = "closeParenthesis";
	    TokenType[TokenType["at"] = (Math.pow(2, 8)) | TokenType.boundary] = "at";
	    TokenType[TokenType["openBrace"] = (Math.pow(2, 9)) | TokenType.boundary] = "openBrace";
	    // [};] are property boundaries:
	    TokenType[TokenType["closeBrace"] = (Math.pow(2, 10)) | TokenType.propertyBoundary | TokenType.boundary] = "closeBrace";
	    TokenType[TokenType["semicolon"] = (Math.pow(2, 11)) | TokenType.propertyBoundary | TokenType.boundary] = "semicolon";
	    // : is a chimaeric abomination:
	    // foo:bar{}
	    // foo:bar;
	    TokenType[TokenType["colon"] = (Math.pow(2, 12)) | TokenType.boundary | TokenType.word] = "colon";
	    // TODO: are these two boundaries? I mean, sometimes they are I guess? Or
	    //       maybe they shouldn't exist in the boundaryTokenTypes map.
	    TokenType[TokenType["hyphen"] = (Math.pow(2, 13))] = "hyphen";
	    TokenType[TokenType["underscore"] = (Math.pow(2, 14))] = "underscore";
	})(TokenType = exports.TokenType || (exports.TokenType = {}));
	/**
	 * Class that describes individual tokens as produced by the Tokenizer.
	 */
	class Token {
	    /**
	     * Create a Token instance.
	     * @param type The lexical type of the Token.
	     * @param start The start index of the text corresponding to the
	     * Token in the CSS text.
	     * @param end The end index of the text corresponding to the Token
	     * in the CSS text.
	     */
	    constructor(type, start, end) {
	        this.type = type;
	        this.start = start;
	        this.end = end;
	        this.previous = null;
	        this.next = null;
	    }
	    /**
	     * Test if the Token matches a given numeric type. Types match if the bitwise
	     * AND of the Token's type and the argument type are equivalent to the
	     * argument type.
	     * @param type The numeric type to test for equivalency with the
	     * Token.
	     */
	    is(type) {
	        return (this.type & type) === type;
	    }
	}
	Token.type = TokenType;
	exports.Token = Token;
	/**
	 * A mapping of boundary token text to their corresponding types.
	 */
	const boundaryTokenTypes = {
	    '(': Token.type.openParenthesis,
	    ')': Token.type.closeParenthesis,
	    ':': Token.type.colon,
	    '@': Token.type.at,
	    '{': Token.type.openBrace,
	    '}': Token.type.closeBrace,
	    ';': Token.type.semicolon,
	    '-': Token.type.hyphen,
	    '_': Token.type.underscore
	};
	exports.boundaryTokenTypes = boundaryTokenTypes;
	
} (token));

var tokenizer = {};

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(tokenizer, "__esModule", { value: true });
const common_1$2 = common;
const token_1$2 = token;
/**
 * Class that implements tokenization of significant lexical features of the
 * CSS syntax.
 */
class Tokenizer {
    /**
     * Create a Tokenizer instance.
     * @param cssText The raw CSS string to be tokenized.
     *
     */
    constructor(cssText) {
        /**
         * Tracks the position of the tokenizer in the source string.
         * Also the default head of the Token linked list.
         */
        this.cursorToken_ = new token_1$2.Token(token_1$2.Token.type.none, 0, 0);
        /**
         * Holds a reference to a Token that is "next" in the source string, often
         * due to having been peeked at.
         */
        this.currentToken_ = null;
        this.cssText = cssText;
    }
    get offset() {
        return this.cursorToken_.end;
    }
    /**
     * The current token that will be returned by a call to `advance`. This
     * reference is useful for "peeking" at the next token ahead in the sequence.
     * If the entire CSS text has been tokenized, the `currentToken` will be null.
     */
    get currentToken() {
        if (this.currentToken_ == null) {
            this.currentToken_ = this.getNextToken_();
        }
        return this.currentToken_;
    }
    /**
     * Advance the Tokenizer to the next token in the sequence.
     * @return The current token prior to the call to `advance`, or null
     * if the entire CSS text has been tokenized.
     */
    advance() {
        let token;
        if (this.currentToken_ != null) {
            token = this.currentToken_;
            this.currentToken_ = null;
        }
        else {
            token = this.getNextToken_();
        }
        return token;
    }
    /**
     * Extract a slice from the CSS text, using two tokens to represent the range
     * of text to be extracted. The extracted text will include all text between
     * the start index of the first token and the offset index of the second token
     * (or the offset index of the first token if the second is not provided).
     * @param startToken The token that represents the beginning of the
     * text range to be extracted.
     * @param endToken The token that represents the end of the text range
     * to be extracted. Defaults to the startToken if no endToken is provided.
     * @return The substring of the CSS text corresponding to the
     * startToken and endToken.
     */
    slice(startToken, endToken = undefined) {
        const { start, end } = this.getRange(startToken, endToken);
        return this.cssText.substring(start, end);
    }
    /**
     * Like `slice`, but returns the offsets into the source, rather than the
     * substring itself.
     */
    getRange(startToken, endToken = undefined) {
        return { start: startToken.start, end: (endToken || startToken).end };
    }
    trimRange({ start, end }) {
        while (start <= end && /\s/.test(this.cssText.charAt(start))) {
            start++;
        }
        while (start <= end && end > 0 && /\s/.test(this.cssText.charAt(end - 1))) {
            end--;
        }
        return { start, end };
    }
    /**
     * Flush all tokens from the Tokenizer.
     * @return An array of all tokens corresponding to the CSS text.
     */
    flush() {
        const tokens = [];
        while (this.currentToken) {
            tokens.push(this.advance());
        }
        return tokens;
    }
    /**
     * Extract the next token from the CSS text and advance the Tokenizer.
     * @return A Token instance, or null if the entire CSS text has beeen
     * tokenized.
     */
    getNextToken_() {
        const character = this.cssText[this.offset];
        let token;
        this.currentToken_ = null;
        if (this.offset >= this.cssText.length) {
            return null;
        }
        else if (common_1$2.matcher.whitespace.test(character)) {
            token = this.tokenizeWhitespace(this.offset);
        }
        else if (common_1$2.matcher.stringBoundary.test(character)) {
            token = this.tokenizeString(this.offset);
        }
        else if (character === '/' && this.cssText[this.offset + 1] === '*') {
            token = this.tokenizeComment(this.offset);
        }
        else if (common_1$2.matcher.boundary.test(character)) {
            token = this.tokenizeBoundary(this.offset);
        }
        else {
            token = this.tokenizeWord(this.offset);
        }
        token.previous = this.cursorToken_;
        this.cursorToken_.next = token;
        this.cursorToken_ = token;
        return token;
    }
    /**
     * Tokenize a string starting at a given offset in the CSS text. A string is
     * any span of text that is wrapped by eclusively paired, non-escaped matching
     * quotation marks.
     * @param offset An offset in the CSS text.
     * @return A string Token instance.
     */
    tokenizeString(offset) {
        const quotation = this.cssText[offset];
        let escaped = false;
        const start = offset;
        let character;
        while (character = this.cssText[++offset]) {
            if (escaped) {
                escaped = false;
                continue;
            }
            if (character === quotation) {
                ++offset;
                break;
            }
            if (character === '\\') {
                escaped = true;
            }
        }
        return new token_1$2.Token(token_1$2.Token.type.string, start, offset);
    }
    /**
     * Tokenize a word starting at a given offset in the CSS text. A word is any
     * span of text that is not whitespace, is not a string, is not a comment and
     * is not a structural delimiter (such as braces and semicolon).
     * @param number An offset in the CSS text.
     * @return A word Token instance.
     */
    tokenizeWord(offset) {
        const start = offset;
        let character;
        // TODO(cdata): change to greedy regex match?
        while ((character = this.cssText[offset]) &&
            !common_1$2.matcher.boundary.test(character)) {
            offset++;
        }
        return new token_1$2.Token(token_1$2.Token.type.word, start, offset);
    }
    /**
     * Tokenize whitespace starting at a given offset in the CSS text. Whitespace
     * is any span of text made up of consecutive spaces, tabs, newlines and other
     * single whitespace characters.
     * @param number An offset in the CSS text.
     * @return A whitespace Token instance.
     */
    tokenizeWhitespace(offset) {
        const start = offset;
        common_1$2.matcher.whitespaceGreedy.lastIndex = offset;
        const match = common_1$2.matcher.whitespaceGreedy.exec(this.cssText);
        if (match != null && match.index === offset) {
            offset = common_1$2.matcher.whitespaceGreedy.lastIndex;
        }
        return new token_1$2.Token(token_1$2.Token.type.whitespace, start, offset);
    }
    /**
     * Tokenize a comment starting at a given offset in the CSS text. A comment is
     * any span of text beginning with the two characters / and *, and ending with
     * a matching counterpart pair of consecurtive characters (* and /).
     * @param number An offset in the CSS text.
     * @return A comment Token instance.
     */
    tokenizeComment(offset) {
        const start = offset;
        common_1$2.matcher.commentGreedy.lastIndex = offset;
        const match = common_1$2.matcher.commentGreedy.exec(this.cssText);
        if (match == null) {
            offset = this.cssText.length;
        }
        else {
            offset = common_1$2.matcher.commentGreedy.lastIndex;
        }
        return new token_1$2.Token(token_1$2.Token.type.comment, start, offset);
    }
    /**
     * Tokenize a boundary at a given offset in the CSS text. A boundary is any
     * single structurally significant character. These characters include braces,
     * semicolons, the "at" symbol and others.
     * @param number An offset in the CSS text.
     * @return A boundary Token instance.
     */
    tokenizeBoundary(offset) {
        // TODO(cdata): Evaluate if this is faster than a switch statement:
        const type = token_1$2.boundaryTokenTypes[this.cssText[offset]] || token_1$2.Token.type.boundary;
        return new token_1$2.Token(type, offset, offset + 1);
    }
}
tokenizer.Tokenizer = Tokenizer;

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(parser, "__esModule", { value: true });
const node_factory_1$1 = nodeFactory;
const token_1$1 = token;
const tokenizer_1$1 = tokenizer;
/**
 * Class that implements a shady CSS parser.
 */
class Parser$1 {
    /**
     * Create a Parser instance. When creating a Parser instance, a specialized
     * NodeFactory can be supplied to implement streaming analysis and
     * manipulation of the CSS AST.
     */
    constructor(nodeFactory = new node_factory_1$1.NodeFactory()) {
        this.nodeFactory = nodeFactory;
    }
    /**
     * Parse CSS and generate an AST.
     * @param cssText The CSS to parse.
     * @return A CSS AST containing nodes that correspond to those
     *     generated by the Parser's NodeFactory.
     */
    parse(cssText) {
        return this.parseStylesheet(new tokenizer_1$1.Tokenizer(cssText));
    }
    /**
     * Consumes tokens from a Tokenizer to parse a Stylesheet node.
     * @param tokenizer A Tokenizer instance.
     */
    parseStylesheet(tokenizer) {
        return this.nodeFactory.stylesheet(this.parseRules(tokenizer), { start: 0, end: tokenizer.cssText.length });
    }
    /**
     * Consumes tokens from a Tokenizer to parse a sequence of rules.
     * @param tokenizer A Tokenizer instance.
     * @return A list of nodes corresponding to rules. For a parser
     *   configured with a basic NodeFactory, any of Comment, AtRule, Ruleset,
     *   Declaration and Discarded nodes may be present in the list.
     */
    parseRules(tokenizer) {
        const rules = [];
        while (tokenizer.currentToken) {
            const rule = this.parseRule(tokenizer);
            if (rule) {
                rules.push(rule);
            }
        }
        return rules;
    }
    /**
     * Consumes tokens from a Tokenizer to parse a single rule.
     * @param tokenizer A Tokenizer instance.
     * @return If the current token in the Tokenizer is whitespace,
     *   returns null. Otherwise, returns the next parseable node.
     */
    parseRule(tokenizer) {
        // Trim leading whitespace:
        const token = tokenizer.currentToken;
        if (token === null) {
            return null;
        }
        if (token.is(token_1$1.Token.type.whitespace)) {
            tokenizer.advance();
            return null;
        }
        else if (token.is(token_1$1.Token.type.comment)) {
            return this.parseComment(tokenizer);
        }
        else if (token.is(token_1$1.Token.type.word)) {
            return this.parseDeclarationOrRuleset(tokenizer);
        }
        else if (token.is(token_1$1.Token.type.propertyBoundary)) {
            return this.parseUnknown(tokenizer);
        }
        else if (token.is(token_1$1.Token.type.at)) {
            return this.parseAtRule(tokenizer);
        }
        else {
            return this.parseUnknown(tokenizer);
        }
    }
    /**
     * Consumes tokens from a Tokenizer to parse a Comment node.
     * @param tokenizer A Tokenizer instance.
     */
    parseComment(tokenizer) {
        const token = tokenizer.advance();
        if (token === null) {
            return null;
        }
        return this.nodeFactory.comment(tokenizer.slice(token), { start: token.start, end: token.end });
    }
    /**
     * Consumes tokens from a Tokenizer through the next boundary token to
     * produce a Discarded node. This supports graceful recovery from many
     * malformed CSS conditions.
     * @param tokenizer A Tokenizer instance.
     */
    parseUnknown(tokenizer) {
        const start = tokenizer.advance();
        let end;
        if (start === null) {
            return null;
        }
        while (tokenizer.currentToken &&
            tokenizer.currentToken.is(token_1$1.Token.type.boundary)) {
            end = tokenizer.advance();
        }
        return this.nodeFactory.discarded(tokenizer.slice(start, end), tokenizer.getRange(start, end));
    }
    /**
     * Consumes tokens from a Tokenizer to parse an At Rule node.
     * @param tokenizer A Tokenizer instance.
     */
    parseAtRule(tokenizer) {
        let name = undefined;
        let nameRange = undefined;
        let rulelist = undefined;
        let parametersStart = undefined;
        let parametersEnd = undefined;
        if (!tokenizer.currentToken) {
            return null;
        }
        const start = tokenizer.currentToken.start;
        while (tokenizer.currentToken) {
            if (tokenizer.currentToken.is(token_1$1.Token.type.whitespace)) {
                tokenizer.advance();
            }
            else if (!name && tokenizer.currentToken.is(token_1$1.Token.type.at)) {
                // Discard the @:
                tokenizer.advance();
                const start = tokenizer.currentToken;
                let end;
                while (tokenizer.currentToken &&
                    tokenizer.currentToken.is(token_1$1.Token.type.word)) {
                    end = tokenizer.advance();
                }
                nameRange = tokenizer.getRange(start, end);
                name = tokenizer.cssText.slice(nameRange.start, nameRange.end);
            }
            else if (tokenizer.currentToken.is(token_1$1.Token.type.openBrace)) {
                rulelist = this.parseRulelist(tokenizer);
                break;
            }
            else if (tokenizer.currentToken.is(token_1$1.Token.type.propertyBoundary)) {
                tokenizer.advance();
                break;
            }
            else {
                if (parametersStart == null) {
                    parametersStart = tokenizer.advance();
                }
                else {
                    parametersEnd = tokenizer.advance();
                }
            }
        }
        if (name === undefined || nameRange === undefined) {
            return null;
        }
        let parametersRange = undefined;
        let parameters = '';
        if (parametersStart) {
            parametersRange = tokenizer.trimRange(tokenizer.getRange(parametersStart, parametersEnd));
            parameters =
                tokenizer.cssText.slice(parametersRange.start, parametersRange.end);
        }
        const end = tokenizer.currentToken ? tokenizer.currentToken.previous.end :
            tokenizer.cssText.length;
        return this.nodeFactory.atRule(name, parameters, rulelist, nameRange, parametersRange, { start, end });
    }
    /**
     * Consumes tokens from a Tokenizer to produce a Rulelist node.
     * @param tokenizer A Tokenizer instance.
     */
    parseRulelist(tokenizer) {
        const rules = [];
        const start = tokenizer.currentToken.start;
        let endToken;
        // Take the opening { boundary:
        tokenizer.advance();
        while (tokenizer.currentToken) {
            if (tokenizer.currentToken.is(token_1$1.Token.type.closeBrace)) {
                endToken = tokenizer.currentToken;
                tokenizer.advance();
                break;
            }
            else {
                const rule = this.parseRule(tokenizer);
                if (rule) {
                    rules.push(rule);
                }
            }
        }
        // If we don't have an end token it's because we reached the end of input.
        const end = endToken ? endToken.end : tokenizer.cssText.length;
        return this.nodeFactory.rulelist(rules, { start, end });
    }
    /**
     * Consumes tokens from a Tokenizer instance to produce a Declaration node or
     * a Ruleset node, as appropriate.
     * @param tokenizer A Tokenizer node.
     */
    parseDeclarationOrRuleset(tokenizer) {
        let ruleStart = null;
        let ruleEnd = null;
        let colon = null;
        // This code is not obviously correct. e.g. there's what looks to be a
        // null-dereference if the declaration starts with an open brace or
        // property boundary.. though that may be impossible.
        while (tokenizer.currentToken) {
            if (tokenizer.currentToken.is(token_1$1.Token.type.whitespace)) {
                tokenizer.advance();
            }
            else if (tokenizer.currentToken.is(token_1$1.Token.type.openParenthesis)) {
                // skip until close paren
                while (tokenizer.currentToken &&
                    !tokenizer.currentToken.is(token_1$1.Token.type.closeParenthesis)) {
                    tokenizer.advance();
                }
            }
            else if (tokenizer.currentToken.is(token_1$1.Token.type.openBrace) ||
                tokenizer.currentToken.is(token_1$1.Token.type.propertyBoundary)) {
                break;
            }
            else {
                if (tokenizer.currentToken.is(token_1$1.Token.type.colon)) {
                    colon = tokenizer.currentToken;
                }
                if (ruleStart === null) {
                    ruleStart = tokenizer.advance();
                    ruleEnd = ruleStart;
                }
                else {
                    ruleEnd = tokenizer.advance();
                }
            }
        }
        if (tokenizer.currentToken === null) {
            // terminated early
            return null;
        }
        // A ruleset never contains or ends with a semi-colon.
        if (tokenizer.currentToken.is(token_1$1.Token.type.propertyBoundary)) {
            const nameRange = tokenizer.getRange(ruleStart, colon ? colon.previous : ruleEnd);
            const declarationName = tokenizer.cssText.slice(nameRange.start, nameRange.end);
            let expression = undefined;
            if (colon && colon.next) {
                const rawExpressionRange = tokenizer.getRange(colon.next, ruleEnd);
                const expressionRange = tokenizer.trimRange(rawExpressionRange);
                const expressionValue = tokenizer.cssText.slice(expressionRange.start, expressionRange.end);
                expression =
                    this.nodeFactory.expression(expressionValue, expressionRange);
            }
            if (tokenizer.currentToken.is(token_1$1.Token.type.semicolon)) {
                tokenizer.advance();
            }
            const range = tokenizer.trimRange(tokenizer.getRange(ruleStart, tokenizer.currentToken && tokenizer.currentToken.previous ||
                ruleEnd));
            return this.nodeFactory.declaration(declarationName, expression, nameRange, range);
            // This is the case for a mixin-like structure:
        }
        else if (colon && colon === ruleEnd) {
            const rulelist = this.parseRulelist(tokenizer);
            if (tokenizer.currentToken.is(token_1$1.Token.type.semicolon)) {
                tokenizer.advance();
            }
            const nameRange = tokenizer.getRange(ruleStart, ruleEnd.previous);
            const declarationName = tokenizer.cssText.slice(nameRange.start, nameRange.end);
            const range = tokenizer.trimRange(tokenizer.getRange(ruleStart, tokenizer.currentToken && tokenizer.currentToken.previous ||
                ruleEnd));
            return this.nodeFactory.declaration(declarationName, rulelist, nameRange, range);
            // Otherwise, this is a ruleset:
        }
        else {
            const selectorRange = tokenizer.getRange(ruleStart, ruleEnd);
            const selector = tokenizer.cssText.slice(selectorRange.start, selectorRange.end);
            const rulelist = this.parseRulelist(tokenizer);
            const start = ruleStart.start;
            let end;
            if (tokenizer.currentToken) {
                end = tokenizer.currentToken.previous ?
                    tokenizer.currentToken.previous.end :
                    ruleStart.end;
            }
            else {
                // no current token? must have reached the end of input, so go up
                // until there
                end = tokenizer.cssText.length;
            }
            return this.nodeFactory.ruleset(selector, rulelist, selectorRange, { start, end });
        }
    }
}
parser.Parser = Parser$1;

var stringifier = {};

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(stringifier, "__esModule", { value: true });
const common_1$1 = common;
const node_visitor_1$1 = nodeVisitor;
/**
 * Class that implements basic stringification of an AST produced by the Parser.
 */
class Stringifier$1 extends node_visitor_1$1.NodeVisitor {
    /**
     * Stringify an AST such as one produced by a Parser.
     * @param ast A node object representing the root of an AST.
     * @return The stringified CSS corresponding to the AST.
     */
    stringify(ast) {
        return this.visit(ast) || '';
    }
    /**
     * Visit and stringify a Stylesheet node.
     * @param stylesheet A Stylesheet node.
     * @return The stringified CSS of the Stylesheet.
     */
    [common_1$1.nodeType.stylesheet](stylesheet) {
        let rules = '';
        for (let i = 0; i < stylesheet.rules.length; ++i) {
            rules += this.visit(stylesheet.rules[i]);
        }
        return rules;
    }
    /**
     * Visit and stringify an At Rule node.
     * @param atRule An At Rule node.
     * @return The stringified CSS of the At Rule.
     */
    [common_1$1.nodeType.atRule](atRule) {
        return `@${atRule.name}` +
            (atRule.parameters ? ` ${atRule.parameters}` : '') +
            (atRule.rulelist ? `${this.visit(atRule.rulelist)}` : ';');
    }
    /**
     * Visit and stringify a Rulelist node.
     * @param rulelist A Rulelist node.
     * @return The stringified CSS of the Rulelist.
     */
    [common_1$1.nodeType.rulelist](rulelist) {
        let rules = '{';
        for (let i = 0; i < rulelist.rules.length; ++i) {
            rules += this.visit(rulelist.rules[i]);
        }
        return rules + '}';
    }
    /**
     * Visit and stringify a Comment node.
     * @param comment A Comment node.
     * @return The stringified CSS of the Comment.
     */
    [common_1$1.nodeType.comment](comment) {
        return `${comment.value}`;
    }
    /**
     * Visit and stringify a Seletor node.
     * @param ruleset A Ruleset node.
     * @return The stringified CSS of the Ruleset.
     */
    [common_1$1.nodeType.ruleset](ruleset) {
        return `${ruleset.selector}${this.visit(ruleset.rulelist)}`;
    }
    /**
     * Visit and stringify a Declaration node.
     * @param declaration A Declaration node.
     * @return The stringified CSS of the Declaration.
     */
    [common_1$1.nodeType.declaration](declaration) {
        return declaration.value != null ?
            `${declaration.name}:${this.visit(declaration.value)};` :
            `${declaration.name};`;
    }
    /**
     * Visit and stringify an Expression node.
     * @param expression An Expression node.
     * @return The stringified CSS of the Expression.
     */
    [common_1$1.nodeType.expression](expression) {
        return `${expression.text}`;
    }
    /**
     * Visit a discarded node.
     * @param discarded A Discarded node.
     * @return An empty string, since Discarded nodes are discarded.
     */
    [common_1$1.nodeType.discarded](_discarded) {
        return '';
    }
}
stringifier.Stringifier = Stringifier$1;

/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
Object.defineProperty(shadyCss, "__esModule", { value: true });
var ast_iterator_1 = astIterator;
shadyCss.iterateOverAst = ast_iterator_1.iterateOverAst;
var common_1 = common;
shadyCss.nodeType = common_1.nodeType;
var node_factory_1 = nodeFactory;
shadyCss.NodeFactory = node_factory_1.NodeFactory;
var node_visitor_1 = nodeVisitor;
shadyCss.NodeVisitor = node_visitor_1.NodeVisitor;
var parser_1 = parser;
var Parser = shadyCss.Parser = parser_1.Parser;
var stringifier_1 = stringifier;
var Stringifier = shadyCss.Stringifier = stringifier_1.Stringifier;
var token_1 = token;
shadyCss.Token = token_1.Token;
var tokenizer_1 = tokenizer;
shadyCss.Tokenizer = tokenizer_1.Tokenizer;

var maybeGetPreviewerIframe = function maybeGetPreviewerIframe() {
  return document.querySelector('.edit-post-visual-editor__content-area iframe[name="editor-canvas"]');
};

var styleTagsCache = null;
var clearAstCache = function clearAstCache() {
  styleTagsCache = null;
};
var getStyleTagsWithAst = function getStyleTagsWithAst() {
  if (styleTagsCache) {
    return styleTagsCache;
  }

  var maybeStyle = document.querySelector('#ct-main-styles-inline-css');

  if (!maybeStyle) {
    return [];
  }

  var parser = new Parser();

  var allStyles = _toConsumableArray(document.querySelectorAll('style')).filter(function (s) {
    return s.innerText && s.innerText.indexOf('narrow-container-max-width') > -1;
  });

  var maybeIframe = maybeGetPreviewerIframe();

  if (maybeIframe) {
    allStyles = [].concat(_toConsumableArray(allStyles), _toConsumableArray(_toConsumableArray(maybeIframe.contentDocument.querySelectorAll('style')).filter(function (s) {
      return s.innerText.indexOf('narrow-container-max-width') > -1;
    })));
  }

  styleTagsCache = allStyles.map(function (style) {
    return {
      style: style,
      ast: parser.parse(style.innerText.replace(new RegExp('\n', 'g'), ''))
    };
  });
  return styleTagsCache;
};
var persistNewAsts = function persistNewAsts(styleTags) {
  styleTagsCache = styleTags;
  var stringifier = new Stringifier();
  styleTagsCache.map(function (styleDescriptor) {
    if (!styleDescriptor.style) {
      console.error('No ast for style', styleDescriptor);
      return;
    }

    styleDescriptor.style.innerText = stringifier.stringify(styleDescriptor.ast);
  });
};
var overrideStylesWithAst = function overrideStylesWithAst() {
  if (!styleTagsCache) {
    return;
  }

  persistNewAsts(styleTagsCache.map(function (styleDescriptor) {
    if (styleDescriptor.style.id) {
      return styleDescriptor;
    }

    var allStyles = _toConsumableArray(document.querySelectorAll('style')).filter(function (s) {
      return s.innerText.indexOf('narrow-container-max-width') > -1;
    });

    var maybeIframe = maybeGetPreviewerIframe();

    if (maybeIframe) {
      allStyles = [].concat(_toConsumableArray(allStyles), _toConsumableArray(_toConsumableArray(maybeIframe.contentDocument.querySelectorAll('style')).filter(function (s) {
        return s.innerText.indexOf('narrow-container-max-width') > -1;
      })));
    }

    styleDescriptor.style = allStyles.find(function (s) {
      return !s.id;
    });
    return _objectSpread2({}, styleDescriptor);
  }));
};

var prepareSpacingValueFor = function prepareSpacingValueFor(value) {
  if ([value['top'], value['right'], value['bottom'], value['left']].reduce(function (isValueCompact, currentValue) {
    return !isValueCompact ? false : !(currentValue !== 'auto' && currentValue && currentValue.toString().match(/\d/g));
  }, true)) {
    return 'CT_CSS_SKIP_RULE';
  }

  var result = [value['top'] === 'auto' || !value['top'].toString().match(/\d/g) ? 0 : value['top'], value['right'] === 'auto' || !value['right'].toString().match(/\d/g) ? 0 : value['right'], value['bottom'] === 'auto' || !value['bottom'].toString().match(/\d/g) ? 0 : value['bottom'], value['left'] === 'auto' || !value['left'].toString().match(/\d/g) ? 0 : value['left']];

  if (result[0] === result[1] && result[0] === result[2] && result[0] === result[3]) {
    return result[0];
  }

  if (result[0] === result[2] && result[1] === result[3]) {
    return "".concat(result[0], " ").concat(result[3]);
  }

  return result.join(' ');
};

var prepareBoxShadowValueFor = function prepareBoxShadowValueFor(value, _ref) {
  var _ref$forcedOutput = _ref.forcedOutput,
      forcedOutput = _ref$forcedOutput === void 0 ? false : _ref$forcedOutput;

  if (value === 'CT_CSS_SKIP_RULE') {
    return 'CT_CSS_SKIP_RULE';
  }

  if (value === 'none') {
    return 'none';
  }

  if (!value.enable) {
    return 'none';
  }

  if (parseFloat(value.blur) === 0 && parseFloat(value.spread) === 0 && parseFloat(value.v_offset) === 0 && parseFloat(value.h_offset) === 0) {
    return forcedOutput ? 'none' : 'CT_CSS_SKIP_RULE';
  }

  var box_shadow_components = [];

  if (value.inset) {
    box_shadow_components.push('inset');
  }

  box_shadow_components.push("".concat(value.h_offset, "px"));
  box_shadow_components.push("".concat(value.v_offset, "px"));

  if (parseFloat(value.blur) !== 0) {
    box_shadow_components.push("".concat(value.blur, "px"));

    if (parseFloat(value.spread) !== 0) {
      box_shadow_components.push("".concat(value.spread, "px"));
    }
  }

  if (parseFloat(value.blur) === 0 && parseFloat(value.spread) !== 0) {
    box_shadow_components.push("".concat(value.blur, "px"));
    box_shadow_components.push("".concat(value.spread, "px"));
  }

  box_shadow_components.push(value.color.color);
  return box_shadow_components.join(' ');
};

var isFunction = function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

var replaceVariableInAst = function replaceVariableInAst() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  args = _objectSpread2({
    variableDescriptor: {},
    value: '',
    ast: {}
  }, args);
  var _args = args,
      variableDescriptor = _args.variableDescriptor,
      value = _args.value,
      ast = _args.ast;
  var newSelector = variableDescriptor.selector || ':root';
  var variablePrefix = '--';

  if (variableDescriptor.variableType === 'property') {
    variablePrefix = '';
  }

  var variableName = "".concat(variablePrefix).concat(isFunction(variableDescriptor.variable) ? variableDescriptor.variable() : variableDescriptor.variable);
  var hasSuchSelector = ast.rules.find(function (_ref) {
    var selector = _ref.selector;
    return selector === newSelector;
  });
  var ruleToCopy = {
    type: 'ruleset',
    selector: ':root',
    rulelist: {
      type: 'rulelist',
      rules: [{
        type: 'declaration',
        name: '--container-max-width',
        value: {
          type: 'expression',
          text: '1290px'
        }
      }]
    }
  };
  var newAst = JSON.parse(JSON.stringify(ast));

  if (hasSuchSelector) {
    newAst.rules = newAst.rules.map(function (rule) {
      var selector = rule.selector;

      if (selector !== newSelector) {
        return rule;
      }

      if (value.indexOf('CT_CSS_SKIP_RULE') > -1 || value.indexOf(variableName) > -1) {
        return _objectSpread2(_objectSpread2({}, rule), {}, {
          rulelist: _objectSpread2(_objectSpread2({}, rule.rulelist), {}, {
            rules: rule.rulelist.rules.filter(function (_ref2) {
              var name = _ref2.name;
              return name !== variableName;
            })
          })
        });
      }

      var hasSuchRule = rule.rulelist.rules.find(function (_ref3) {
        var name = _ref3.name;
        return name === variableName;
      });

      if (hasSuchRule) {
        return _objectSpread2(_objectSpread2({}, rule), {}, {
          rulelist: _objectSpread2(_objectSpread2({}, rule.rulelist), {}, {
            rules: rule.rulelist.rules.map(function (rule) {
              if (rule.name === variableName) {
                return _objectSpread2(_objectSpread2({}, rule), {}, {
                  value: _objectSpread2(_objectSpread2({}, rule.value), {}, {
                    text: value
                  })
                });
              }

              return rule;
            })
          })
        });
      }

      return _objectSpread2(_objectSpread2({}, rule), {}, {
        rulelist: _objectSpread2(_objectSpread2({}, rule.rulelist), {}, {
          rules: [].concat(_toConsumableArray(rule.rulelist.rules), [_objectSpread2(_objectSpread2({}, ruleToCopy.rulelist.rules[0]), {}, {
            name: variableName,
            value: _objectSpread2(_objectSpread2({}, ruleToCopy.rulelist.rules[0].value), {}, {
              text: value
            })
          })])
        })
      });
    });
  }

  if (!hasSuchSelector && value.indexOf('CT_CSS_SKIP_RULE') === -1) {
    newAst.rules = [].concat(_toConsumableArray(newAst.rules), [_objectSpread2(_objectSpread2({}, ruleToCopy), {}, {
      selector: newSelector,
      rulelist: _objectSpread2(_objectSpread2({}, ruleToCopy.rulelist), {}, {
        rules: [_objectSpread2(_objectSpread2({}, ruleToCopy.rulelist.rules[0]), {}, {
          name: variableName,
          value: _objectSpread2(_objectSpread2({}, ruleToCopy.rulelist.rules[0].value), {}, {
            text: value
          })
        })]
      })
    })]);
  }

  return newAst;
};

var replacingLogic = function replacingLogic() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  args = _objectSpread2({
    variableDescriptor: {},
    value: {},
    ast: {}
  }, args);
  var actualValue = args.value;

  if ((args.variableDescriptor.type || '').indexOf('color') > -1 && args.value !== 'CT_CSS_SKIP_RULE') {
    actualValue = args.value[args.variableDescriptor.type === 'color' ? 'default' : args.variableDescriptor.type.split(':')[1]].color;
  }

  if ((args.variableDescriptor.type || '') === 'border') {
    actualValue = !args.value || args.value.style === 'none' ? 'none' : "".concat(args.value.width, "px ").concat(args.value.style, " ").concat(args.value.color.color);

    if (args.variableDescriptor.skip_none && actualValue === 'none') {
      actualValue = 'CT_CSS_SKIP_RULE';
    }
  }

  if ((args.variableDescriptor.type || '') === 'spacing') {
    actualValue = prepareSpacingValueFor(args.value);
  }

  if ((args.variableDescriptor.type || '') === 'box-shadow') {
    actualValue = prepareBoxShadowValueFor(args.value, args.variableDescriptor);
  }

  return replaceVariableInAst({
    variableDescriptor: args.variableDescriptor,
    value: "".concat(actualValue).concat(args.variableDescriptor.unit || '').concat(args.variableDescriptor.important ? ' !important' : ''),
    ast: args.ast
  });
};

var updateVariableInStyleTags = function updateVariableInStyleTags() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  args = _objectSpread2({
    variableDescriptor: {},
    value: '',
    fullValue: {},
    tabletMQ: '(max-width: 999.98px)',
    mobileMQ: '(max-width: 689.98px)'
  }, args);
  var allDescriptors = args.variableDescriptor;

  if (isFunction(allDescriptors)) {
    allDescriptors = allDescriptors(args.value);
  }

  if (!Array.isArray(allDescriptors)) {
    allDescriptors = [allDescriptors];
  }

  persistNewAsts(getStyleTagsWithAst().map(function (styleDescriptor) {
    return _objectSpread2(_objectSpread2({}, styleDescriptor), {}, {
      ast: allDescriptors.reduce(function (currentAst, variableDescriptor) {
        var value = variableDescriptor.fullValue ? args.fullValue : args.value;
        value = variableDescriptor.extractValue ? variableDescriptor.extractValue(value) : value;

        if (variableDescriptor.whenDone) {
          variableDescriptor.whenDone(value, args.value);
        }

        value = maybePromoteScalarValueIntoResponsive(value, !!variableDescriptor.responsive);

        if (!variableDescriptor.responsive) {
          return replacingLogic({
            variableDescriptor: variableDescriptor,
            value: value,
            ast: currentAst
          });
        }

        var desktopAst = replacingLogic({
          variableDescriptor: variableDescriptor,
          value: value.desktop,
          ast: currentAst
        });
        var tabletAst = desktopAst;

        if (!tabletAst.rules.find(function (_ref) {
          var type = _ref.type,
              parameters = _ref.parameters;
          return type === 'atRule' && parameters === args.tabletMQ;
        })) {
          tabletAst = _objectSpread2(_objectSpread2({}, tabletAst), {}, {
            rules: [].concat(_toConsumableArray(tabletAst.rules), [{
              type: 'atRule',
              name: 'media',
              parameters: args.tabletMQ,
              rulelist: {
                type: 'rulelist',
                rules: []
              }
            }])
          });
        }

        tabletAst = _objectSpread2(_objectSpread2({}, tabletAst), {}, {
          rules: tabletAst.rules.map(function (rule) {
            if (rule.type !== 'atRule' || rule.parameters !== args.tabletMQ) {
              return rule;
            }

            return _objectSpread2(_objectSpread2({}, rule), {}, {
              rulelist: replacingLogic({
                variableDescriptor: _objectSpread2(_objectSpread2({}, variableDescriptor), {}, {
                  selector: variableDescriptor.selector === '.edit-post-visual-editor__content-area > div' ? ':root' : variableDescriptor.selector
                }),
                value: value.tablet,
                ast: rule.rulelist
              })
            });
          })
        });
        var mobileAst = tabletAst;

        if (!mobileAst.rules.find(function (_ref2) {
          var type = _ref2.type,
              parameters = _ref2.parameters;
          return type === 'atRule' && parameters === args.mobileMQ;
        })) {
          mobileAst = _objectSpread2(_objectSpread2({}, mobileAst), {}, {
            rules: [].concat(_toConsumableArray(mobileAst.rules), [{
              type: 'atRule',
              name: 'media',
              parameters: args.mobileMQ,
              rulelist: {
                type: 'rulelist',
                rules: []
              }
            }])
          });
        }

        mobileAst = _objectSpread2(_objectSpread2({}, mobileAst), {}, {
          rules: mobileAst.rules.map(function (rule) {
            if (rule.type !== 'atRule' || rule.parameters !== args.mobileMQ) {
              return rule;
            }

            return _objectSpread2(_objectSpread2({}, rule), {}, {
              rulelist: replacingLogic({
                variableDescriptor: _objectSpread2(_objectSpread2({}, variableDescriptor), {}, {
                  selector: variableDescriptor.selector === '.edit-post-visual-editor__content-area > div' ? ':root' : variableDescriptor.selector
                }),
                value: value.mobile,
                ast: rule.rulelist
              })
            });
          })
        });
        return mobileAst;
      }, styleDescriptor.ast)
    });
  }));
};

export { clearAstCache, overrideStylesWithAst, updateVariableInStyleTags };
//# sourceMappingURL=index.es.js.map
